import GeneralDetails from './GeneralDetails';

export default GeneralDetails;
